import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserService } from '../../shared/services/user.service';

/**
 * Gates every authenticated route.
 *
 * Inventory Management is an internal staff portal. The Company SSO cookie is
 * visible to every app on the shared domain, so a valid token alone is not
 * enough — the session must belong to an Internal user. External accounts
 * (consignors, donors) are bounced back to Company login.
 */
export const authGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  return userService.checkAuthentication();
};
